import { Sparkles } from "lucide-react";
import * as React from "react";

import { Box } from "@mui/system";

type SparkleProps = {
  size?: number;
};

const ContainedSparkle = ({ size }: SparkleProps) => (
  <Box
    sx={{
      width: "24px",
      height: "24px",
      borderRadius: "5.714px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "white",
      background:
        "linear-gradient(135deg, rgb(152, 16, 250) 0%, rgb(21, 93, 252) 100%)",
    }}
  >
    <Sparkles size={size} color={"white"} />
  </Box>
);

const DefaultSparkle = ({ size = 16 }: SparkleProps) => (
  <Sparkles size={size} />
);

const PurpleSparkle = ({ size = 16 }: SparkleProps) => (
  <Box
    sx={{
      display: "inline-flex",
      "& svg": {
        stroke: "url(#purpleGradient)",
      },
    }}
  >
    <svg width={0} height={0} style={{ position: "absolute" }}>
      <defs>
        <linearGradient id="purpleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#9810FA" />
          <stop offset="100%" stopColor="#155DFC" />
        </linearGradient>
      </defs>
    </svg>
    <Sparkles size={size} />
  </Box>
);

export const Sparkle = ({
  size = 16,
  variant = "default",
}: {
  size?: number;
  variant?: "contained" | "purple" | "default";
}) => {
  if (variant === "contained") {
    return <ContainedSparkle size={size} />;
  }
  if (variant === "purple") {
    return (
      <Box>
        <PurpleSparkle size={size} />
      </Box>
    );
  }

  return <DefaultSparkle size={size} />;
};
